"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var getState_1 = require("../../../../../../utils/getState");
var DebtInformation = function (_a) {
    var debt = _a.debt;
    return (React.createElement("div", null,
        (0, getState_1.default)().user.role !== 'customer' ? (React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "split_panel_description flex-column" },
                React.createElement("h3", null, "Debt Owed To"),
                React.createElement("span", null,
                    React.createElement("span", { className: "debt-information-subheader" },
                        React.createElement("h4", { className: "company_name_click", onClick: function () { return (window.location.href = "/admin/companies/".concat(debt.debtor.company_id)); } }, debt.company !== undefined ? debt.company.name : null)))))) : null,
        React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "split_panel_description flex-column" },
                React.createElement("div", { className: "left flex-column" },
                    React.createElement("h3", { className: "debt-information-header" }, "Debt Information"),
                    React.createElement("span", null,
                        React.createElement("span", { className: "debt-information-subheader flex-row" },
                            React.createElement("h4", null, "Goods/Services Provided")),
                        React.createElement("div", null, debt.goods_description !== null && debt.goods_description !== '' ? debt.goods_description : ''),
                        React.createElement("div", null, debt.services_description !== null && debt.services_description !== ''
                            ? debt.services_description
                            : '')),
                    React.createElement("span", null,
                        React.createElement("span", { className: "debt-information-subheader flex-row" },
                            React.createElement("h4", null, "Invoice Sent")),
                        React.createElement("div", null, debt.invoice_sent_date)),
                    React.createElement("span", null,
                        React.createElement("span", { className: "debt-information-subheader flex-row" },
                            React.createElement("h4", null, "Debt Due")),
                        React.createElement("div", null, debt.invoice_due_date)),
                    React.createElement("span", null,
                        React.createElement("span", { className: "debt-information-subheader flex-row" },
                            React.createElement("h4", null, "Jurisdiction")),
                        React.createElement("div", null, debt.jurisdiction === 'england_wales' ? 'England and Wales' : 'Scotland')),
                    React.createElement("span", null,
                        React.createElement("span", { className: "debt-information-subheader flex-row" },
                            React.createElement("h4", null, "Reference No.")),
                        React.createElement("div", null, debt.invoice_reference))))),
        React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "split_panel_description flex-column" },
                React.createElement("div", { className: "right" },
                    React.createElement("h3", { className: "debt-information-header" }, "Debtor Information"),
                    React.createElement("span", { className: "debt-information-subheader flex-row" },
                        React.createElement("h4", null, "Name")),
                    React.createElement("span", null, debt.debtor.name),
                    React.createElement("span", { className: "debt-information-subheader flex-row" },
                        React.createElement("h4", null, "Email")),
                    React.createElement("span", null, debt.debtor.email),
                    React.createElement("span", { className: "debt-information-subheader flex-row" },
                        React.createElement("h4", null, "Debtor Type")),
                    React.createElement("span", null, debt.debtor.protocol_id === 1 ? 'Individual/Sole Trader' : 'Commercial'),
                    React.createElement("span", { className: "debt-information-subheader flex-column" },
                        React.createElement("h4", null, "Address"),
                        React.createElement("span", null, debt.debtor.address_1),
                        React.createElement("span", null, debt.debtor.address_2),
                        React.createElement("span", null, debt.debtor.city),
                        React.createElement("span", null, debt.debtor.country),
                        React.createElement("span", null, debt.debtor.post_code)))))));
};
exports.default = DebtInformation;
